import React from 'react'
import { isJustGiving } from '../../../../lib/environment'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import { edhLight, edhDark, jgLight, jgDark } from '../../../../assets'

const PoweredBy = ({ classNames, environment = 'default', theme }) => {
  const defaultEnvironment = isJustGiving() ? 'justgiving' : 'everydayhero'
  const logoEnvironment =
    environment === 'default' ? defaultEnvironment : environment

  return (
    <div>
      <div className={classNames.label}>Powered by</div>
      {logoEnvironment === 'everydayhero' ? (
        <img
          src={theme === 'light' ? edhLight : edhDark}
          alt='Everydayhero'
          className={classNames.logo}
        />
      ) : (
        <img
          src={theme === 'light' ? jgLight : jgDark}
          alt='JustGiving'
          className={classNames.logo}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(PoweredBy)



// WEBPACK FOOTER //
// ./components/container/Footer/PoweredBy/index.js